import Image from 'next/image';

import { styles } from './UiReviewTileProduct.styles';

const PLACEHOLDER_IMAGE_URL = '/images/product/placeholder.png';

type ProductCardColor = 'primary' | 'secondary';

export interface UiReviewTileProductProps {
  title: string;
  shortDescription?: string;
  tags?: string[];
  imageUrl?: string;
  color?: ProductCardColor;
  url?: string;
}

export function UiReviewTileProduct({
  title,
  tags,
  shortDescription,
  imageUrl,
  color = 'primary',
  url
}: UiReviewTileProductProps) {
  const slots = styles({ color });

  const content = (
    <>
      <div className={slots.imageWrapper()}>
        <Image
          src={imageUrl || PLACEHOLDER_IMAGE_URL}
          alt={title}
          className={slots.image()}
          fill
        />
      </div>
      <div className={slots.info()}>
        <h3 className={slots.title()}>{title}</h3>
        {tags && tags.length > 0 && tags[0].trim().length > 0 && (
          <div className={slots.tags()}>
            {tags?.map((tag) => (
              <div
                key={tag}
                className={slots.tag()}
              >
                {tag}
              </div>
            ))}
          </div>
        )}
        {shortDescription && (
          <div className={slots.description()}>{shortDescription}</div>
        )}
      </div>
    </>
  );

  if (url) {
    return (
      <a
        href={url}
        target="_blank"
        rel="noopener noreferrer"
        className={slots.base()}
      >
        {content}
      </a>
    );
  }

  return <div className={slots.base()}>{content}</div>;
}
